// Copyright The Perses Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { PersesColor } from './types';

export const purple: PersesColor = {
  50: '#EFE9FD',
  100: '#E0D2FC',
  150: '#D0BCFA',
  200: '#C1A6F8',
  300: '#A179F5',
  400: '#824DF1',
  500: '#6320EE',
  600: '#4F1ABE',
  700: '#3B138F',
  800: '#280D5F',
  850: '#1E0A47',
  900: '#140630',
  950: '#0A0318',
};
